import React, {Component} from 'react'
import {connect} from 'react-redux'
import * as irActions from '../../../redux/actions/irSearch'
import LoadingBar from '../../common/LoadingBar'
import AlertError from '../../common/AlertError'
import FilterTable from '../../common/FilterTable'
import UpdateFromPacer from '../../common/UpdateFromPacer'

class CaseSummary extends Component {

    componentDidMount() {
        if (this.props.purchase_right_away)
            this.purchaseSummaryData();
        else
            this.getSummaryData();
    }

    getSummaryData = () => {
        this.props.dispatch(irActions.getCaseData({
            type: 'case_summary',
            case_uuid: this.props.case_uuid,
        }));
    }

    purchaseSummaryData = () => {
        this.props.dispatch(irActions.purchaseCaseData({
            type: 'case_summary',
            case_uuid: this.props.case_uuid,
        }));
    }

    render() {
        if (!this.props.dataReady) return <LoadingBar/>;

        const alertError = this.props.error ? <AlertError errors={ this.props.error }/> : null;

        const SummaryData = this.props.summary;

        return (
            <div className="ir-search-query case-summary">
                { alertError }
                <FilterTable>
                    {!!SummaryData.length ? (
                        <div dangerouslySetInnerHTML={{__html: SummaryData}}/>
                    ) : (
                        <div
                            className="ir-search-status-message messages warning"
                        >There Are No Summary Data For This Case</div>
                    )}
                </FilterTable>
                <UpdateFromPacer
                    pacerUpdateHandler={ this.purchaseSummaryData }
                    pacerReceipt={this.props.receipt}
                    lastUpdated={this.props.lastUpdated}/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const irSearch = state.get('irSearch').toJS();

    return {
        dataReady: irSearch.data_ready,
        summary: irSearch.data,
        receipt: irSearch.receipt,
        lastUpdated: irSearch.lastUpdated,
        error: irSearch.error
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseSummary);


/** WEBPACK FOOTER **
 ** ./src/components/case/summary/CaseSummary.js
 **/